// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  getAnalytics,
  isSupported,
  logEvent as firebaseLogEvent,
} from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCjKqw2VTUe_6wnLewVuh9SZTna6uplN_g",
  authDomain: "mindblowscom.firebaseapp.com",
  projectId: "mindblowscom",
  storageBucket: "mindblowscom.firebasestorage.app",
  messagingSenderId: "850915248514",
  appId: "1:850915248514:web:2e60ec61556331dc56e79b",
  measurementId: "G-2C1YJ69R0P",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

let analytics = null;
isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

// Safe logEvent wrapper
export const logEvent = (name, params) => {
  if (analytics) {
    firebaseLogEvent(analytics, name, params);
  } else {
    console.log("Analytics not supported or not yet initialized.");
  }
};
